import { Route, Routes } from 'react-router-dom'

import ThinkIntro from './ThinkIntro'
import ThinkInfo from './ThinkInfo'
import ThinkPayBefore from './ThinkPayBefore'
import ThinkPayAfter from './ThinkPayAfter'
import ThinkLoading from './ThinkLoading'

// thinkpool
const Index = () => {
	return (
		<Routes>
			<Route path="/thinkLoading" element={<ThinkLoading />} /> { /* 씽크풀 로딩페이지 */}
			<Route path="/thinkPayAfter" element={<ThinkPayAfter />} /> { /* 씽크풀 상품구매(결제 후) */}
			<Route path="/thinkPayBefore" element={<ThinkPayBefore />} /> { /* 씽크풀 상품구매(결제 전) */}
			<Route path="/thinkInfo" element={<ThinkInfo />} /> { /* 씽크풀 이용안내 */}
			<Route path="/thinkIntro" element={<ThinkIntro />} /> { /* 씽크풀 서비스 소개 */}
		</Routes>
	)
}

export default Index